import React from 'react';
import { Box, CircularProgress } from '@mui/material';

import styles from './style';

// The rail of the actions: avatar, like, comments, favorite, share.
const RAIL_ITEMS = [0, 1, 2, 3, 4];

// Card of the feed before its first page arrives: same size and place as the player and its actions.
const FeedPlayerSkeleton: React.FC = React.memo(() => (
  <>
    <Box sx={styles.frame} aria-hidden>
      <CircularProgress size={34} sx={styles.spinner} />
      <Box sx={styles.info}>
        <Box sx={styles.username} />
        <Box sx={styles.line} />
        <Box sx={styles.shortLine} />
        <Box sx={styles.progress} />
      </Box>
    </Box>
    <Box sx={styles.rail} aria-hidden>
      {RAIL_ITEMS.map((item) => (
        <Box key={item} sx={styles.railItem} />
      ))}
    </Box>
  </>
));

export default FeedPlayerSkeleton;
